import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningIguazu.css';

const DiningIguazu: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'restaurant',
      image: images.iguazuRestaurant || images.restaurantFeature,
      title: 'Our Restaurant',
      content: 'Awasi Iguazú restaurant crafts dishes rooted in local ingredients and inspired by the culinary traditions of the region, creating an experience as rich and authentic as the surrounding landscape.'
    },
    {
      id: 'cuisine',
      image: images.iguazuDining2 || images.foodImage,
      title: 'Tropical fruit, freshwater fish, the scent of citrus and yerba mate',
      content: 'Our cuisine celebrates local ingredients and honours the rich culinary heritage of the Guaraní people. The region\'s rich biodiversity encourages the use of wild fruits, fresh river fish and edible plants sourced directly from the Atlantic Rainforest.'
    },
    {
      id: 'chef',
      image: images.chefMauricioAlvez || images.teamMember2,
      title: 'Mauricio Alvez - Head Chef',
      content: 'Mauricio Alvez is the Chef of Awasi Iguazú. A Misiones native, he began his culinary journey alongside his grandmother. He highlights the rich ingredients and traditions of his homeland, focusing on seasonal fruits, local cheeses and fresh fish.'
    },
    {
      id: 'ingredients',
      image: images.iguazuDining3 || images.foodImage,
      title: 'Farm-to-table, local flavours',
      content: 'Our kitchen celebrates the incredible bounty of Misiones Province. Fresh river fish from pristine rivers, tropical fruits from the Atlantic Rainforest, and the authentic ritual of yerba mate showcase the region\'s incredible biodiversity.'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="iguazu" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => (
            <div key={panel.id} className="dining-panel">
              <div className="dining-panel__image">
                <img src={panel.image} alt={panel.title} />
              </div>
              <div className="dining-panel__content">
                <h2 className="dining-panel__title">{panel.title}</h2>
                <p className="dining-panel__text">{panel.content}</p>
                <button className="dining-panel__cta">CONTACT US</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="iguazu" />
    </div>
  );
};

export default DiningIguazu;